import './RolesPage.css'
import React, {  useEffect } from "react";
import Header from '../../components/common/Header/Header';
import { AppDispatch } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import RolesContainer from './components/RolesContainer';
import { fetchRoles } from '../../redux/actions/roles.actions';
import RootState from '../../redux/states/root.state';
import { LayersIcon } from '../../components/common/Icons/Icons';

const RolesPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.roles);

  // Dispatch UseEffects
  useEffect(() => {
    dispatch(fetchRoles(searchParams.toString()));
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <Header
        header="Roles"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><LayersIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Roles</li>
          </ul>
        }
      />
      <main className="lp-main">
        <RolesContainer/>
      </main>
    </div>
  );
};

export default RolesPage;
